import GrupoActivoService from "@/api/services/finanzas/nomencladores/GrupoService"
import Vue from "vue"

const state = () => ({
    agrupos: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    AGRUPOS: state => {
        return state.agrupos
    },
    AGRUPOS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_AGRUPOS: (state, payload) => {
        state.agrupos = payload
    },

    SET_AGRUPOS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_AGRUPO: (state, payload) => {
        state.agrupos.push(payload)
    },

    UPDATE_AGRUPO: (state, payload) => {
        state.agrupos = state.agrupos.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_AGRUPO: (state, payload) => {
        state.agrupos = state.agrupos.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_AGRUPOS: async ({ commit, state }, { filter, grupoEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await GrupoActivoService.get({ filter, grupoEstado, ...pagination })
            if (status === 200) {
                commit("SET_AGRUPOS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los grupos del activo, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_AGRUPOS: async ({ commit }) => {
        try {
            let { data, status } = await GrupoActivoService.getAll()
            if (status === 200) {
                commit("SET_AGRUPOS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_AGRUPOS: async ({ commit }) => {
        try {
            let { data, status } = await GrupoActivoService.getAllRecords()
            if (status === 200) {
                commit("SET_AGRUPOS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los grupos del activo, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_ACTIVO_GRUPO: async ({ commit }, payload) => {
        try {
            let { data, status } = await GrupoActivoService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_AGRUPO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial para el grupo del activo, inténtelo nuevamente"
            })
        }
    },

    ADD_AGRUPO: async ({ commit }, payload) => {
        try {
            let { data, status } = await GrupoActivoService.post(payload)
            if (status === 201) {
                commit("ADD_AGRUPO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El grupo ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el grupo, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_AGRUPO: async ({ commit }, payload) => {
        try {
            let { data, status } = await GrupoActivoService.put(payload)
            if (status === 200) {
                commit("UPDATE_AGRUPO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El grupo ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el grupo, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_AGRUPO: async ({ commit }, payload) => {
        try {
            let { status, data } = await GrupoActivoService.delete(payload)
            if (status === 204) {
                commit("DELETE_AGRUPO", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El grupo ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_AGRUPO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El grupo ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el grupo del activo, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
